import { useCallback, useState } from 'react';
import { analyticsTrack } from 'utils/analytics';

export type PopoverTriggerSource =
  | 'escape button'
  | 'outside click'
  | 'apply button'
  | 'clear button'
  | 'enter button'
  | 'availability button';

function usePopoverTrigger(filterCategory: string) {
  const [show, setShow] = useState(false);

  const togglePopover = useCallback(() => {
    if (!show) {
      analyticsTrack(
        {
          type: 'click',
          subject: `open filter`,
          value: { filterCategory },
          valueString: filterCategory,
        },
        {
          category: 'Search page',
          action: 'click',
          label: `Filter ${filterCategory}`,
        },
      );
    }
    setShow((prevShow) => !prevShow);
  }, [show, filterCategory]);

  const closePopover = ({
    source,
    callback,
  }: {
    source: PopoverTriggerSource;
    callback?: () => void;
  }) => {
    setShow(false);
    if (callback) {
      callback();
    }
  };

  return { show, togglePopover, closePopover };
}

export default usePopoverTrigger;
